import React from "react";
import { withStyles, Button } from "@material-ui/core";
import styles from "./style";
import { DateTimeEditor } from "../../../dataGrid/cellEditors";
import appConstant from "../../../../appConstants";
import { formatDateYear } from "../../../dataGrid/gridUtilities";
import CustomTextField from "../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField";
import StyledSelect from "../../../common/StyledSelect";
import CircularProgress from "@material-ui/core/CircularProgress";
import { isValid as isDateTimeValid } from "date-fns";
import { compose } from "recompose";
import WithDrawer from "../../Dispatch/Common/Drawer/WithDrawer";
import { postData } from "../../../../api/componentAPIs";
import { withSnackbar } from "notistack";

class AddEditHoliday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      holidayDetails: this.getNewHoliday(),
      holidayDetailsError: {
        holidayName: null,
        holidayDate: null,
        countryApplicable: null,
        stateApplicable: null,
        terminalApplicable: null,
      },
      errorMessage: null,
      holidayUpdateInProgress: false,
    };
  }

  getNewHoliday = () => {
    const { holidayDetails } = this.props;
    return {
      holidayId: holidayDetails?.holidayId || null,
      holidayName: holidayDetails?.holidayName || null,
      holidayDate: holidayDetails?.holidayDate || null,
      countryApplicable: holidayDetails?.countryApplicable?.join(",") || "",
      stateApplicable: holidayDetails?.stateApplicable?.join(",") || "",
      terminalApplicable: holidayDetails?.terminalApplicable?.join(",") || "",
    };
  };

  // Update holiday Details based on inputs
  handleChange = (name) => (value) => {
    if (name === "terminalApplicable") {
      value = value?.map((x) => x.label).join(",") || null;
    } else if (name === "stateApplicable") {
      value = value?.map((x) => x.label).join(",") || null;
    } else if (name === "countryApplicable") {
      value = value?.map((x) => x.label).join(",") || null;
    }
    this.setState((state) => ({
      holidayDetails: {
        ...state.holidayDetails,
        [name]: value,
      },
      holidayDetailsError: {
        ...state.holidayDetailsError,
        [name]: this.getFieldError(name, value),
      },
      errorMessage: this.getHolidayFormError,
    }));
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "holidayName":
        return value?.trim() ? null : "* Holiday name is required";
      case "holidayDate":
        return value?.trim() ? null : "* Holiday Date is required";
      default:
        return null;
    }
  };

  // Set Error messages for each field
  getErrorInfo = () => {
    let holidayDetailsError = {};
    Object.keys(this.state.holidayDetails).forEach((fieldName) => {
      holidayDetailsError[fieldName] = this.getFieldError(
        fieldName,
        this.state.holidayDetails[fieldName]
      );
    });
    this.setState({
      holidayDetailsError,
    });
    return holidayDetailsError;
  };

  getHolidayFormError = (holidayDetails) => {
    if (
      !holidayDetails.countryApplicable &&
      !holidayDetails.stateApplicable &&
      !holidayDetails.terminalApplicable
    ) {
      return "Country, State, Terminal select at least one";
    } else {
      return "";
    }
  };

  updateHolidayDate = (value) => {
    if (!value && this.state.holidayDetails.holidayDate !== value) {
      this.handleChange("holidayDate")(null);
    } else if (
      isDateTimeValid(value) &&
      this.state.holidayDetails.holidayDate !== value
    ) {
      this.handleChange("holidayDate")(value);
    }
  };

  saveHolidayData = () => {
    const errorMessage = this.getHolidayFormError(this.state.holidayDetails);
    this.setState({ errorMessage });
    const errorInfo = this.getErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    if (!errorMessage && !error) {
      this.saveHoliday(this.state.holidayDetails);
    }
  };

  getCountryApplicableData = (holidayData) => {
    if (
      holidayData.terminalApplicable?.length > 0 ||
      holidayData.stateApplicable?.length > 0
    ) {
      return [];
    } else {
      return holidayData.countryApplicable?.split(",") || [];
    }
  };
  getStateApplicableData = (holidayData) => {
    if (holidayData.terminalApplicable?.length > 0) {
      return [];
    } else {
      return holidayData.stateApplicable?.split(",") || [];
    }
  };

  saveHoliday = (holidayData) => {
    this.setState({
      holidayUpdateInProgress: true,
    });
    const requestData = {
      ...holidayData,
      countryApplicable: this.getCountryApplicableData(holidayData),
      stateApplicable: this.getStateApplicableData(holidayData),
      terminalApplicable: holidayData.terminalApplicable?.split(",") || [],
    };
    const isNewHoliday = !holidayData.holidayId;
    postData("SaveHoliday", requestData).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          this.props.enqueueSnackbar(
            ` Holiday ${isNewHoliday ? "created" : "updated"} successfully`,
            {
              variant: "success",
            }
          );
          this.setState({
            holidayUpdateInProgress: false,
            userUpdateError: "",
          });
          this.props.onClose([response.data.holidayId]);
          this.props.getAllHolidays();
        } else {
          this.props.enqueueSnackbar(
            `Error while ${isNewHoliday ? "creating" : "updating"} holiday`,
            {
              variant: "error",
            }
          );
          this.setState({
            holidayUpdateInProgress: false,
          });
          this.props.onClose();
        }
      },
      (error) => {
        this.props.enqueueSnackbar(
          `Error while ${isNewHoliday ? "creating" : "updating"} holiday`,
          {
            variant: "error",
          }
        );
        this.setState({
          holidayUpdateInProgress: false,
        });
        this.props.onClose();
      }
    );
  };

  getStateOptions = (stateList, countryApplicable) => {
    return countryApplicable?.length > 0
      ? stateList.filter((state) => countryApplicable.includes(state.country))
      : stateList;
  };

  getTerminalOptions = (terminalList, holidayDetails) => {
    if (holidayDetails.stateApplicable?.length > 0) {
      return terminalList.filter((terminal) =>
        holidayDetails.stateApplicable.includes(terminal.state)
      );
    } else if (holidayDetails.countryApplicable?.length > 0) {
      return terminalList.filter((terminal) =>
        holidayDetails.countryApplicable.includes(terminal.country)
      );
    } else {
      return terminalList;
    }
  };

  render() {
    const { classes, terminalList, countryList, stateList } = this.props;
    const { holidayDetails, holidayDetailsError } = this.state;
    const holidayDate = holidayDetails.holidayDate
      ? formatDateYear({ value: holidayDetails.holidayDate })
      : null;
    const disableCountry =
      Boolean(holidayDetails?.terminalApplicable) ||
      Boolean(holidayDetails?.stateApplicable);
    const disableState = Boolean(holidayDetails?.terminalApplicable);
    const stateOption = this.getStateOptions(
      stateList,
      holidayDetails.countryApplicable
    );
    const terminalOption = this.getTerminalOptions(
      terminalList,
      holidayDetails
    );
    return (
      <>
        <div>
          <header className={classes.moduleHeader}>
            {holidayDetails.holidayId ? "Update Holiday" : "Add Holiday"}
          </header>
          <div className={classes.formContainer}>
            <div className={classes.formValue}>
              <div
                className={
                  Boolean(holidayDetailsError.holidayDate)
                    ? classes.editTimeContainerError
                    : classes.editTimeContainer
                }
              >
                <DateTimeEditor
                  dateType={appConstant.DATETYPES.DATEYEAR}
                  InputLabelProps={{
                    classes: {
                      root: classes.labelProps,
                      filled: classes.filledLabel,
                      shrink: classes.shrink,
                    },
                  }}
                  inputRootClass={classes.timeEditorInput}
                  label="Holiday Date"
                  onChange={this.updateHolidayDate}
                  value={holidayDate}
                  variant="filled"
                  disableFocus
                  enablePickerPortal
                  disableFocusInput
                  inputFocusedClass={classes.timeEditorInputFocused}
                />
                {Boolean(holidayDetailsError.holidayDate) && (
                  <p
                    className={`MuiFormHelperText-root MuiFormHelperText-error ${classes.errorMessageVisible}`}
                  >
                    {holidayDetailsError.holidayDate}
                  </p>
                )}
              </div>
            </div>

            <div className={classes.formValue}>
              <CustomTextField
                id="HolidayName"
                label="Holiday Name"
                handleChange={this.handleChange("holidayName")}
                error={holidayDetailsError.holidayName}
                value={holidayDetails.holidayName}
                hideIncrementer
              />
            </div>

            <div className={classes.formValue}>
              <StyledSelect
                textFieldProps={{
                  id: "Country",
                  label: "Country",
                  variant: "outlined",
                  helperText: "",
                }}
                value={holidayDetails?.countryApplicable?.split(",") || null}
                error={holidayDetailsError.countryApplicable}
                onChange={this.handleChange("countryApplicable")}
                data={countryList}
                rootClass={disableCountry ? classes.inputDisabled : ""}
                isMulti={true}
                isDisabled={disableCountry}
              />
            </div>

            <div className={classes.formValue}>
              <StyledSelect
                textFieldProps={{
                  id: "State",
                  label: "State",
                  variant: "outlined",
                  helperText: "",
                }}
                rootClass={disableState ? classes.inputDisabled : ""}
                value={holidayDetails?.stateApplicable?.split(",") || null}
                error={holidayDetailsError.stateApplicable}
                onChange={this.handleChange("stateApplicable")}
                data={stateOption}
                isMulti={true}
                isDisabled={disableState}
              />
            </div>

            <div className={classes.formValue}>
              <StyledSelect
                textFieldProps={{
                  id: "Terminal",
                  label: "Terminal",
                  variant: "outlined",
                  helperText: "",
                }}
                value={holidayDetails?.terminalApplicable?.split(",") || null}
                error={holidayDetailsError.terminalApplicable}
                onChange={this.handleChange("terminalApplicable")}
                data={terminalOption}
                isMulti={true}
              />
            </div>

            {this.state.errorMessage && (
              <div className={classes.errorMessage}>
                {this.state.errorMessage}
              </div>
            )}
          </div>
          <div className={classes.actionContainer}>
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={this.props.onClose}
              classes={{ root: classes.actionButton }}
              id="closeButton"
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              type="submit"
              onClick={this.saveHolidayData}
              disabled={this.state.holidayUpdateInProgress}
              classes={{
                root: classes.actionButton,
                disabled: classes.actionButtonDisabled,
              }}
            >
              {this.state.holidayUpdateInProgress ? (
                <CircularProgress
                  size={16}
                  classes={{ root: classes.circularProgress }}
                />
              ) : holidayDetails.holidayId ? (
                "Update"
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  WithDrawer,
  withSnackbar,
  withStyles(styles)
)(AddEditHoliday);
